import {
  CustomFieldExtensionSchema,
  FieldExtensionComponentProps,
} from '@backstage/plugin-scaffolder-react';
import {
  FormControlLabel,
  FormLabel,
  Link,
  Radio,
  RadioGroup,
  Typography,
  useTheme,
} from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import { themedefault } from '@principal/design-system-tokens';

import { FieldValidation } from '@rjsf/utils';
import { useAtomValue } from 'jotai';
import { useState } from 'react';
import { teamNameAtom } from '../github-teams/TeamName';

export const AssociateAdminSchema: CustomFieldExtensionSchema = {
  returnValue: { type: 'string' },
};

export const AdminAssociation = ({
  onChange,
  rawErrors,
  required,
  formData,
}: FieldExtensionComponentProps<string>) => {
  const [checked, setChecked] = useState(formData);

  const teamName = useAtomValue(teamNameAtom);
  const theme = useTheme();

  const handleChange = (event: any) => {
    onChange(event.target?.value);
    setChecked(event.target?.value);
  };

  return (
    <>
      <div>
        <h3>Create associated admin group</h3>
        <Typography>
          Creating an associated admin AD group allows you to identify those who
          should have full access while maintaining the overall team.
        </Typography>
        <FormControl
          margin="normal"
          required={required}
          error={rawErrors !== undefined && rawErrors.length > 0 && !formData}
        >
          <FormLabel
            id="admin-group-value"
            style={{ color: 'black' }}
            required={required}
          >
            Choose Yes/No to create an associated admin group for your AD backed
            GitHub team
          </FormLabel>
          <RadioGroup
            aria-labelledby="admin-group-value"
            name="admin-group-value"
            value={formData}
            onChange={handleChange}
            row
          >
            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="No" control={<Radio />} label="No" />
          </RadioGroup>
          {checked === 'Yes' && (
            <h3
              style={{
                padding: '1rem 1.75rem',
                backgroundColor: themedefault.BaseColorBlueSoft10,
                fontWeight: 400,
                borderRadius: 4,
                width: 'max-content',
                minWidth: '450px',
                color: theme.palette.common.black,
              }}
            >
              Resulting admin team names:{' '}
              <ul style={{ margin: '.5rem 0 0' }}>
                <li>
                  <strong>GITHUB-{teamName}-ADMIN</strong>{' '}
                  <span>(Azure / PDP)</span>
                </li>
                <li>
                  <strong>{teamName}-ADMIN</strong> <span>(GitHub)</span>
                </li>
              </ul>
            </h3>
          )}
        </FormControl>
      </div>
      <Typography variant="body1">
        Learn more about this process from{' '}
        <Link
          target="_blank"
          href="/docs/principalinformationservices-emu/template/principal-developer-portal-templates-team-creation"
        >
          the documentation
        </Link>
        .
      </Typography>
    </>
  );
};

export const AdminAssociationValidation = async (
  formData: string,
  validation: FieldValidation,
) => {
  if (formData !== 'Yes' && formData !== 'No') {
    validation.addError('Please select Yes or No to attach an admin group.');
  }
};
